import { Link } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import {
  Cog6ToothIcon,
  QuestionMarkCircleIcon,
  ArrowRightStartOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { useUserPreferences } from "../../hooks/useUserPreferences";
import { useAuth } from "../../contexts/AuthContext";
import CircularInitialsAvatar from "../Shared/CircularInitialsAvatar";

const itemClass =
  "flex w-full items-center gap-x-3 px-3 py-2 text-sm text-ink-700 data-[focus]:bg-cream-100 transition-colors";
const iconClass = "h-5 w-5 shrink-0 text-ink-400";

const ProfileDropdown = () => {
  const { firstName, lastName, fullName, isLoading } = useUserPreferences();
  const { user, logout } = useAuth();

  const getInitials = () => {
    if (!firstName) return "";
    if (!lastName) return firstName.charAt(0).toUpperCase();
    return `${firstName.charAt(0).toUpperCase()}${lastName
      .charAt(0)
      .toUpperCase()}`;
  };

  const handleSignOut = async (e) => {
    e.preventDefault();
    await logout();
  };

  const openCrispChat = () => {
    if (window.$crisp) {
      window.$crisp.push(["do", "chat:show"]);
      window.$crisp.push(["do", "chat:open"]);
    }
  };

  return (
    <Menu as="div" className="relative">
      <MenuButton className="-m-1.5 flex items-center p-1.5 rounded-pill hover:bg-cream-100 transition-colors">
        <span className="sr-only">Open user menu</span>
        <CircularInitialsAvatar initials={getInitials()} size="medium" />
        <span className="hidden sm:flex sm:items-center">
          <span
            aria-hidden="true"
            className="ml-3 text-sm font-medium leading-6 text-ink-900"
          >
            {isLoading ? "Loading..." : fullName || "User"}
          </span>
        </span>
        <ChevronDownIcon
          aria-hidden="true"
          className="ml-1.5 h-4 w-4 text-ink-400"
        />
      </MenuButton>
      <MenuItems
        anchor="bottom end"
        className="z-20 w-64 origin-top-right rounded-card bg-cream-50 py-2 shadow-lift ring-1 ring-ink-100 focus:outline-none mt-2"
      >
        <div className="px-3 py-2 border-b border-ink-100">
          <p className="text-sm font-medium text-ink-900 truncate">
            {fullName || "User"}
          </p>
          {user?.email && (
            <p className="text-xs text-ink-500 truncate">{user.email}</p>
          )}
        </div>

        <div className="py-1">
          <MenuItem>
            <Link to="/settings" className={itemClass}>
              <Cog6ToothIcon aria-hidden="true" className={iconClass} />
              Settings
            </Link>
          </MenuItem>
          <MenuItem>
            <button
              type="button"
              onClick={openCrispChat}
              className={itemClass}
            >
              <QuestionMarkCircleIcon
                aria-hidden="true"
                className={iconClass}
              />
              Help & support
            </button>
          </MenuItem>
        </div>

        <div className="py-1 border-t border-ink-100">
          <MenuItem>
            <button
              type="button"
              onClick={handleSignOut}
              className={itemClass}
            >
              <ArrowRightStartOnRectangleIcon
                aria-hidden="true"
                className={iconClass}
              />
              Sign out
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
};

export default ProfileDropdown;
